import {
  comboboxError,
  comboboxIsFocused,
  comboboxLabel,
  comboboxWrapper,
  inputError,
} from '../multi-select-combobox/multi-select-combobox.css.ts';
import { themeVars } from '../theme/vars.ts';
import { fontWeight, space } from '../tokens.ts';
import { typography } from '../typography.ts';
import { globalStyle, style } from '../layer.css';

export const multiEmail = style([
  comboboxWrapper,
  typography.bodyMd,
  {
    flexDirection: 'row',
    flexWrap: 'wrap',
  },
]);

export const multiEmailIsFocused = style([comboboxIsFocused]);
export const multiEmailWithError = style([comboboxError]);

globalStyle(`${multiEmail} > span[data-placeholder]`, {
  display: 'none',
  position: 'absolute',
  top: '50%',
  transform: 'translateY(-50%) translateX(3px)',
});

globalStyle(`${multiEmail}.empty > span[data-placeholder]`, {
  display: 'inline',
  color: themeVars.color.text.tertiary,
});

globalStyle(`${multiEmail} > input`, {
  flex: 1,
  width: 'auto',
  outline: 'none',
  border: '0 none',
  display: 'inline-block',
  lineHeight: 1,
  verticalAlign: 'baseline',
  backgroundColor: 'transparent',
});

export const multiEmailLabel = style([comboboxLabel]);
export const multiEmailError = style([inputError]);

export const emailTag = style([
  typography.bodyMd,
  {
    display: 'flex',
    alignItems: 'center',
    gap: space.s2,
    fontWeight: fontWeight.bold,
  },
]);
